import {SelectItem, SelectList, SelectPopover, SelectTrigger} from '@/components/ui/select-atoms/SelectAtoms'
import {SelectProvider} from '@ariakit/react'
import dayjs from 'dayjs'
import {useDayPicker} from 'react-day-picker'

interface RangeCalendarYearSelectProps {
    currentDate: Date
    onYearChange: (date: Date) => void
}

export const RangeCalendarYearSelect = ({currentDate, onYearChange}: RangeCalendarYearSelectProps) => {
    const {goToMonth} = useDayPicker()

    const getYearOptions = (): [string, string][] => {
        return Array.from({length: 110}, (_, i) => {
            const year = dayjs().year() - 100 + i
            return [year.toString(), year.toString()]
        })
    }

    const handleYearChange = (value: string) => {
        const newYear = parseInt(value, 10)
        const newDate = dayjs(currentDate).year(newYear).toDate()
        onYearChange(newDate)
        goToMonth(newDate)
    }

    const currentYear = dayjs(currentDate).year().toString()

    return (
        <SelectProvider value={currentYear} setValue={handleYearChange}>
            <SelectTrigger
                style={{outline: 'none', boxShadow: 'none'}}
                value={currentYear}
                displayValue={value => value}
            />
            <SelectPopover>
                <SelectList>
                    {getYearOptions().map(([value, label]) => (
                        <SelectItem key={value} value={value} hasItemCheckbox={false}>
                            {label}
                        </SelectItem>
                    ))}
                </SelectList>
            </SelectPopover>
        </SelectProvider>
    )
}
